<template>
    <div class="account">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>企业账户</el-breadcrumb-item>
        </el-breadcrumb>

        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="手机号">
                    <el-input v-model="query.phone" placeholder="手机号"></el-input>
                </el-form-item>
                <el-form-item label="所属企业" prop="epId" >
                    <el-select v-model="query.epId" filterable placeholder="请选择">
                        <el-option
                                v-for="item in enterprises"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">

            <el-button type="primary" style="margin-bottom: 1rem" @click="$router.push('/epUser/create')" size="small">创建账号</el-button>
            <el-table
                    :data="accounts"
                    v-loading="loading"
                    style="width: 100%">
                <el-table-column
                        prop="phone"
                        sortable
                        label="手机号"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.epName ? a.epName.localeCompare(b.epName, 'zh') : -1"
                        prop="epName"
                        label="企业名称"
                >
                </el-table-column>
                <el-table-column
                        prop="type"
                        sortable
                        label="账号类型"
                >
                    <template slot-scope="scope">
                        {{scope.row.type == 1 ? "店员" : scope.row.type == 2 ? "主管" : "经理"}}
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="creator"
                        label="创建人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="createTime"
                        label="创建时间"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updator"
                        label="更新人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updateTime"
                        label="更新时间"
                >
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="$router.push('/epUser/edit?id=' + scope.row.id)" type="text" size="small" >编辑</el-button>
                        <!--                        <el-button @click="$router.push('/user/address?id=' + scope.row.id)" type="text" size="small">配送地址</el-button>-->
                        <el-button @click="deleteDevice(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: center">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import accountApi from "../../api/epUser";
    import enterpriseApi from "../../api/enterprise";
    import {mapState} from "vuex";

    export default {
        data: function () {
            return {
                accounts: [],
                query: {},
                enterprises: [],
                loading: false,
                total: 0,
                pagination: {
                    page: sessionStorage.getItem("page") || 1,
                    pageSize: 10
                },
            }
        },
        computed: {
            ...mapState("auth", {
                auth: state => state
            }),
        },
        mounted() {
            this.loadAccounts();
            this.loadEnterprises();
        },
        methods: {
            loadAccounts: function () {
                this.loading = true;
                accountApi.getAll({...this.query, ...this.pagination}).then(result => {
                    this.loading = false;
                    this.accounts = result.data;
                    this.total = result.total;
                })
            },
            loadEnterprises: function () {
                enterpriseApi.getAll2().then(res => {
                    this.enterprises = res;

                })
            },
            onQuery: function () {
                this.pagination = {
                    page: 1,
                    pageSize: 10
                }
                this.loadAccounts();
            },
            deleteDevice: function(id) {
                this.$confirm('确定删除该账户？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    accountApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadAccounts();
                    })
                });
            },
            handleSizeChange: function (size) {
                this.pagination = {
                    page: 1,
                    pageSize: size
                }
                this.loadAccounts();
            },
            handleCurrentChange: function (page) {
                sessionStorage.setItem("page", page);
                this.pagination = {
                    ...this.pagination,
                    page: page,
                }
                this.loadAccounts();
            },
        }
    }
</script>
